module.exports = __webpack_public_path__ + "media/images/form-icon-nav-hover-2da0bd914d0cc4d53566a355cb279d39.svg";